"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _queryStringParser = _interopRequireDefault(require("../../query-string-parser/query-string-parser"));

var _baseHttpClient = _interopRequireDefault(require("../../http-client/base-http-client"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const KEYS = {
  JWT: 'wordpress-jwt',
  JWT_URL: 'wordpress-jwt-url',
  NONCE: 'wordpress-nonce',
  REFRESH_URL: 'wordpress-refresh-url',
  PHOTOS_URL: 'wordpress-photos-url'
};

class WordpressHttpClient extends _baseHttpClient.default {
  /**
   * Refresh the JWT token
   * @param {Object} ctx - ctx object
   */
  async refreshToken(ctx) {
    let response;

    try {
      response = await this.fetchRefreshToken(ctx);
    } catch (ex) {
      this.onRefreshNonce();
      return false;
    }

    const {
      jwt
    } = response;
    this.setJWT(ctx, jwt);
    return true;
  }
  /**
   * Returns the JWT token
   * @param {Object} ctx - ctx object
   */


  getJwtToken(ctx) {
    return this.getToken(ctx, KEYS.JWT);
  }
  /**
   * Returns the JWT url
   * @param {Object} ctx - ctx object
   */


  getJwtUrl(ctx) {
    return this.getToken(ctx, KEYS.JWT_URL);
  }
  /**
   * Returns the nonce
   * @param {Object} ctx - ctx object
   */


  getNonce(ctx) {
    return this.getToken(ctx, KEYS.NONCE);
  }
  /**
   * Returns the refresh url
   * @param {Object} ctx - ctx object
   */


  getRefreshUrl(ctx) {
    return this.getToken(ctx, KEYS.REFRESH_URL);
  }
  /**
   * Returns the photos url
   * @param {Object} ctx - ctx object
   */


  getPhotosUrl(ctx) {
    return this.getToken(ctx, KEYS.PHOTOS_URL);
  }
  /**
   * Sets the JWT inside the storage
   * @param {Object} ctx - ctx object
   * @param {string} jwt - JWT token
   */


  setJWT(ctx, jwt) {
    this.setToken(ctx, KEYS.JWT, jwt);
  }
  /**
   * Sets the JWT url inside the storage
   * @param {Object} ctx - ctx object
   * @param {string} jwtUrl - JWT url
   */


  setJwtUrl(ctx, jwtUrl) {
    this.setToken(ctx, KEYS.JWT_URL, jwtUrl);
  }
  /**
   * Sets the nonce inside the storage
   * @param {Object} ctx - ctx object
   * @param {string} nonce - nonce
   */


  setNonce(ctx, nonce) {
    this.setToken(ctx, KEYS.NONCE, nonce);
  }
  /**
   * Sets the refresh url inside the storage
   * @param {Object} ctx - ctx object
   * @param {string} refreshUrl - refresh url
   */


  setRefreshUrl(ctx, refreshUrl) {
    this.setToken(ctx, KEYS.REFRESH_URL, refreshUrl);
  }
  /**
   * Sets the photos url inside the storage
   * @param {Object} ctx - ctx object
   * @param {string} photosUrl - photos url
   */


  setPhotosUrl(ctx, photosUrl) {
    this.setToken(ctx, KEYS.PHOTOS_URL, photosUrl);
  }

  async fetchRefreshToken(ctx) {
    const jwtUrl = this.getJwtUrl(ctx);
    return this.getJwt(ctx, jwtUrl, {
      skipResolve: true
    });
  }
  /**
   * Returns the required request config that includes the headers
   * with the nonce
   */


  getWordpressRequestConfig() {
    return {
      headers: {
        'X-Wp-Nonce': this.getNonce()
      },
      withCredentials: true
    };
  }
  /**
   * Fetch the JWT token from the server
   * @param {Object} ctx - ctx object
   * @param {string} jwtUrl - JWT url
   * @param {Object} config - config object
   */


  async getJwt(ctx, jwtUrl, config = {}) {
    const {
      forceRenew,
      skipResolve
    } = config;
    let params;

    if (forceRenew) {
      params = {
        force: 1
      };
    }

    const url = _queryStringParser.default.parseUrl(jwtUrl, params);

    const response = await this.get(url, ctx, _objectSpread(_objectSpread({}, this.getWordpressRequestConfig()), {}, {
      skipResolve
    }));

    if (!response) {
      return false;
    }

    const {
      jwt
    } = response.data;
    return {
      jwt
    };
  }
  /**
   * Force to renew the existing JWT
   * @param {Object} ctx - ctx object
   */


  async forceRenewJwt(ctx) {
    const jwtUrl = this.getJwtUrl(ctx);
    return this.getJwt(ctx, jwtUrl, {
      forceRenew: true,
      skipResolve: true
    });
  }
  /**
   * Fetch the config urls
   * @param {Object} ctx - ctx object
   * @param {string} configUrl - config url
   */


  async getConfig(ctx, configUrl) {
    const response = await this.get(configUrl, ctx, _objectSpread({}, this.getWordpressRequestConfig()));

    if (!response) {
      return false;
    } // eslint-disable-next-line camelcase


    const {
      jwt_url,
      photos_url,
      refresh_url
    } = response.data;
    return {
      jwtUrl: jwt_url,
      photosUrl: photos_url,
      refreshUrl: refresh_url
    };
  }
  /**
   * Returns the user account information from the JWT token
   * @param {Object} ctx
   */


  getUserAccount(ctx) {
    const decodeJWT = super.getUserAccount(ctx);

    if (!decodeJWT) {
      return null;
    }

    const {
      user
    } = decodeJWT;
    return _objectSpread({}, user);
  }
  /**
   * Returns the auth url of the application
   * @param {string} authUrl - auth url
   * @param {string} nonce - nonce
   * @param {string} jwtUrl - JWT url
   * @param {string} configUrl - config url
   * @param {string} redirectUrl - redirect url
   */


  getAuthUrl({
    authUrl,
    nonce,
    jwtUrl,
    configUrl,
    redirectUrl
  }) {
    return _queryStringParser.default.parseUrl(authUrl, {
      nonce,
      jwtUrl,
      configUrl,
      redirectUrl
    });
  }
  /**
   * Returns the url that will renew the nonce
   * @param {string} redirectUrl - redirect url
   * @param {string} refreshUrl - refresh url
   */


  getNonceUrl(redirectUrl, refreshUrl) {
    return _queryStringParser.default.parseUrl(refreshUrl, {
      redirectUrl
    });
  }

}

var _default = WordpressHttpClient;
exports.default = _default;